<template>
    <div
        class="ticket-packages-filter-drawer"
        :class="{ 'is-open': isOpen }"
        @click="toggleDrawer"
    >
        <div class="container" @click.stop>
            <header>
                <h2>{{ trans.filters.filters }}</h2>
                <button class="button button-icon" @click="toggleDrawer">
                    <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13 1L7 7L1 0.999999"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M1 13L7 7L13 13"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </header>

            <div class="content">
                <collapse
                    :title="trans.filters.dates"
                    :content="filterOptions.dates"
                    defaultOpened
                >
                    <div class="items items--dates">
                        <div class="group">
                            <button
                                v-for="date in filterOptions.dates.slice(0, 2)"
                                :key="date.value"
                                class="item"
                                :class="{
                                    active: filters.dates.includes(date.value)
                                }"
                                @click="handleItemClick(date.value, 'dates')"
                            >
                                <strong>{{ date.date }}</strong>
                                {{ date.group }}
                            </button>
                        </div>

                        <div class="group">
                            <button
                                v-for="date in filterOptions.dates.slice(2, 5)"
                                :key="date.value"
                                class="item"
                                :class="{
                                    active: filters.dates.includes(date.value)
                                }"
                                @click="handleItemClick(date.value, 'dates')"
                            >
                                <strong>{{ date.date }}</strong>
                                {{ date.group }}
                            </button>
                        </div>

                        <div class="group">
                            <button
                                v-for="date in filterOptions.dates.slice(5, 6)"
                                :key="date.value"
                                class="item"
                                :class="{
                                    active: filters.dates.includes(date.value)
                                }"
                                @click="handleItemClick(date.value, 'dates')"
                            >
                                <strong>{{ date.date }}</strong>
                                {{ date.group }}
                            </button>
                        </div>
                    </div>
                </collapse>

                <collapse
                    :title="trans.filters.types"
                    :content="filterOptions.types"
                    defaultOpened
                >
                    <div class="items items--types">
                        <button
                            v-for="type in filterOptions.types"
                            :key="type.value"
                            class="item"
                            :class="{
                                active: filters.types.includes(type.value)
                            }"
                            @click="handleItemClick(type.value, 'types')"
                        >
                            <svg-icon :name="type.value" />
                            {{ type.label }}
                        </button>
                    </div>
                </collapse>

                <!-- <collapse :title="trans.filters.prices" :content="[]" defaultOpened></collapse> -->

                <collapse
                    :title="trans.filters.includes"
                    :content="filterOptions.inclusions"
                    defaultOpened
                >
                    <div class="items items--includes">
                        <button
                            v-for="include in filterOptions.inclusions"
                            :key="include.value"
                            class="item"
                            :class="{
                                active: filters.inclusions.includes(
                                    include.value
                                )
                            }"
                            @click="
                                handleItemClick(include.value, 'inclusions')
                            "
                        >
                            <img
                                :src="include.icon"
                                class="include-icon"
                                :alt="include.name"
                                :title="include.name"
                            />
                            {{ include.label }}
                        </button>
                    </div>
                </collapse>
            </div>

            <footer>
                <button class="button action-reset" @click="resetFilters">
                    {{ trans.filters.reset }}
                </button>
                <button class="button action-apply" @click="toggleDrawer">
                    {{ totalTickets }} {{ trans.filters.tickets_packages }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import Collapse from "../../general/Collapse.vue";
import SvgIcon from "../../general/SvgIcon.vue";

export default {
    components: {
        Collapse,
        SvgIcon
    },

    props: {
        isOpen: {
            type: Boolean,
            required: true
        },
        filters: {
            type: Object,
            default: () => ({
                dates: [],
                types: [],
                inclusions: []
            })
        },
        filterOptions: {
            type: Object,
            default: () => ({
                dates: [],
                types: [],
                inclusions: []
            })
        },
        totalTickets: {
            type: Number,
            required: true
        },
        trans: {
            type: Object,
            required: true
        }
    },

    data() {
        return {};
    },
    methods: {
        toggleDrawer() {
            this.$emit("toggle-drawer");
        },
        handleItemClick(value, filter) {
            const currentFilters = [...this.filters[filter]];
            if (currentFilters.includes(value)) {
                currentFilters.splice(currentFilters.indexOf(value), 1);
            } else {
                currentFilters.push(value);
            }
            const updatedFilters = {
                ...this.filters,
                [filter]: currentFilters
            };
            this.$emit("filter-change", updatedFilters);
        },
        resetFilters() {
            const resetFilters = {
                dates: [],
                types: [],
                prices: [],
                inclusions: [],
                locationAndSector: []
            };
            this.$emit("filter-change", resetFilters);
        }
    }
};
</script>

<style lang="scss" scoped>
.items--includes .include-icon {
    width: 20px;
    height: 20px;
    max-width: 20px;
    margin-right: 8px;
    vertical-align: middle;
    flex-shrink: 0;
}
</style>
